/**
 * @fileoverview This file was generated by the Angular template compiler. Do not edit.
 *
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride,checkTypes}
 * tslint:disable
 */ 
var styles = ["[_ngcontent-%COMP%]:root{--mmi-background-color:#eef2f5;--mmi-bottombar-bg-color:#4e5b61;--mmi-bottombar-bg-darken:#354248;--mmi-primary-btn:#F3953F;--mmi-secondary-btn:#58a4c0;--mmi-btn-colour-3:#58a4c0;--mmi-btn-colour-4:#58a4c0;--green-color:#54D89F;--red-color:#EC506E;--login-page-bg-color:#4e5b61}[_nghost-%COMP%]{position:absolute;bottom:0;right:0;background:#95a0b1;font-size:9.96px;color:#fff;border-radius:0 0 5px;height:21px;padding:6.5px;display:-webkit-box;display:-ms-flexbox;display:flex;-webkit-box-align:center;-ms-flex-align:center;align-items:center;visibility:collapse}.borderless[_nghost-%COMP%]{border-radius:0}.has-value[_nghost-%COMP%]{visibility:visible}"];
export { styles as styles };



// WEBPACK FOOTER //
// ./src/app/main/post-overview/post-type-display/post-type-display.component.scss.shim.ngstyle.js.pre-build-optimizer.js